import Vue from 'vue';
import Router from 'vue-router';
import AuthView from '@/app/auth/AuthView.vue';
import StorageRepository from '@/app/common/repository/StorageRepository';
// auth
import Login from '@/app/auth/login/route';
import Register from '@/app/auth/register/route';
import AfterRegister from '@/app/auth/afterRegister/route';
import RemindPassword from '@/app/auth/remindPassword/route';
import ResetPassword from '@/app/auth/resetPassword/route';
import ActivateAccount from '@/app/auth/activateAccount/route';
import store from '@/app/store/store';

Vue.use(Router);
const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'AuthContainer',
      component: AuthView,
      children: [
        Login,
        Register,
        AfterRegister,
        RemindPassword,
        ResetPassword,
        ActivateAccount,
      ],
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  const isPublic = to.matched.some(record => record.meta.public);
  const loggedIn = !!StorageRepository.getUserInfo();
  if (to.path === '/logout') {
    StorageRepository.clearCredentials();
    // @ts-ignore
    return next({
      name: 'Login',
    });
  }
  if (to.path === '/') {
    return next({
      name: 'Login',
    })
  }
  if (!isPublic && !loggedIn) {
    return next({
      name: 'Login',
    });
  }
  return next();
});

export default router;
